<template>
    <CHeader with-subheader>
        <CToggler
            in-header
            class="ml-3 d-lg-none"
            @click="$store.dispatch('panel/toggleSidebarMobile')"
        />
        <CToggler
            in-header
            class="ml-3 d-md-down-none"
            @click="$store.dispatch('panel/toggleSidebarDesktop')"
        />
        <CHeaderBrand class="mx-auto d-lg-none" to="/">
            <!-- <CIcon name="logo" height="48" alt="Logo" /> -->
            <img
                alt="Leadgrease logo"
                class="img-fluid"
                :style="{
                    height: '37px',
                }"
                src="@sset/leadgrease_black.png"
            />
        </CHeaderBrand>
        <CHeaderNav class="d-md-down-none mr-auto">
            <CHeaderNavLink
                to="/admin/langs"
                v-if="isAuthorized(['ADMIN_ROLE'], storeAuthUser.groups)"
            >
                <div>{{ $t("langs") }}</div>
            </CHeaderNavLink>
            <CDropdown
                inNav
                class="c-header-nav-items"
                v-if="isAuthorized(['ADMIN_ROLE'], storeAuthUser.groups)"
            >
                <template #toggler>
                    <CHeaderNavLink>
                        <div>{{ $t("headers") }}</div>
                    </CHeaderNavLink>
                </template>
                <CDropdownItem @click="$router.push({ name: 'tags' })">
                    {{ $t("tags") }}
                </CDropdownItem>
                <CDropdownItem @click="$router.push({ name: 'fields' })">
                    {{ $t("fields") }}
                </CDropdownItem>
            </CDropdown>
        </CHeaderNav>
        <CHeaderNav>
            <SelectGlobalLanguage
                :placeholder="$t('select_a_language')"
                size="sm"
            />
            <Notifications />
            <HeaderAccount />
            <CHeaderNavItem class="px-3">
                <button
                    @click="() => $store.dispatch('panel/toggle', 'darkMode')"
                    class="c-header-nav-btn"
                >
                    <CIcon v-if="darkMode" name="cil-sun" />
                    <CIcon v-else name="cil-moon" />
                </button>
            </CHeaderNavItem>
        </CHeaderNav>
    </CHeader>
</template>

<script>
import HeaderAccount from "./headerAccount";
import SelectGlobalLanguage from "£lement/SelectGlobalLanguage";
import Notifications from "£lement/Notifications";
import { mapGetters } from "vuex";
import baseMixin from "~/mixins/base";

export default {
    mixins: [baseMixin],
    components: {
        HeaderAccount,
        SelectGlobalLanguage,
        Notifications,
    },

    computed: {
        ...mapGetters({
            darkMode: "panel/darkMode",
            storeAuthUser: "auth/user",
        }),
    },
};
</script>
